import { render, staticRenderFns } from "./DisbursementInputTypeInfo.vue?vue&type=template&id=2388c881&"
import script from "./DisbursementInputTypeInfo.vue?vue&type=script&lang=js&"
export * from "./DisbursementInputTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QExpansionItem,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QExpansionItem,QSeparator})
